// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LayoutPublic .table th[data-v-26738bed],.LayoutPublic .table td[data-v-26738bed]{align-content:start;padding:0.75rem}.LayoutPublic .table th *[data-v-26738bed]:last-child,.LayoutPublic .table td *[data-v-26738bed]:last-child{padding-bottom:0;margin-bottom:0}.LayoutPublic .table ul[data-v-26738bed]{padding-left:1.5em}\n", ""]);
// Exports
module.exports = exports;
